import $ from 'jquery';
import 'jquery-ui/ui/effect';

export default class ScrollTo {
  init () {
    // console.log('ScrollTo init');
    $('a[href^="#"]').on('click', function(event) {
      // const offset = 0;
      const target = $(this.getAttribute('href'));
      const offset = $(this).attr('data-offset') || 0;
      // const headerHeight = $('.js-header').height() || 0;
      const headerHeight = 0;

      if (target.length) {
        event.preventDefault();

        $('html, body').stop().animate({
          scrollTop: target.offset().top - headerHeight - offset,
        }, 500, 'easeOutExpo');
      }
    });
  }
}
